import { io, Socket } from 'socket.io-client';
import helper from '@/constants/helper';

let socket: Socket | null = null;
let lastConnectionToken = '';

export const getAuthToken = () => {
  const token = localStorage.getItem(helper.JWT_TOKEN);
  return token ? `Bearer ${token}` : '';
};

const buildAuthPayload = () => {
  const token = getAuthToken();
  lastConnectionToken = token;
  return { token };
};

export const getSocket = () => {
  if (!socket) {
    socket = io(process.env.REACT_APP_API_URL!, {
      auth: (cb) => {
        cb(buildAuthPayload());
      },
      extraHeaders: {
        token: getAuthToken(),
      },
    });
  }

  return socket;
};

export const reconnectSocketWithLatestToken = () => {
  if (!socket) return false;

  const latestToken = getAuthToken();
  if (!latestToken || latestToken === lastConnectionToken) return false;

  socket.connect();
  return true;
};

export const disconnectSocket = () => {
  if (!socket) return;
  socket.disconnect();
  socket = null;
  lastConnectionToken = '';
};
